<template>
  <div class="hero">
    <div class="left">
        <div class="left-text">
            <h1>EPIWATCH<sup>®</sup></h1>
            <h3 class="sub">Independent.<br/>
              Resilient.<br/>
              Trusted.<br/>
              Health intelligence in a changing world.</h3>
            <div class="explore-box mobile" onclick="location.href='https://ui.epiwatch.app/map';" >
              <div class="pin">
                <img src="/home/marker.svg" alt="marker"/>
              </div>
              <div class="explore">
                Explore
              </div>
            </div>
            <p class="desc">
              When other data sources may be interrupted, censored, noisy or unreliable, EPIWATCH<sup>®</sup> keeps you in the picture with real-time global situational awareness.
            </p>
        </div>
        <!-- <StatsPanel/> -->
    </div>
    
    <div class="right mobile-hide">
      <div class="explore-box">
        <div class="pin">
            <img src="/home/marker.svg" alt="marker"/>
          </div>
          <div class="explore" onclick="location.href='https://ui.epiwatch.app/map';">
            Explore
          </div>
        </div>
    </div>
    </div>
</template>
<script>
    // import StatsPanel from './StatsPanel.vue';
    export default {
        name: "HeroSection",
        components: {
            // StatsPanel
        }
    }
</script>